import React, { Component } from "react";
import { FaEllipsisV } from "react-icons/fa";
import themeLarge from "../ThemeLarge";
import Dropdown from "bootstrap/js/dist/dropdown";
import { FaRegCalendarAlt } from "react-icons/fa";

class PublishedBlogsList extends Component {
  componentDidMount() {
    this.initializeDropdowns();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.publishedBlogs !== this.props.publishedBlogs) {
      this.initializeDropdowns();
    }
  }

  initializeDropdowns = () => {
    document.querySelectorAll('[data-bs-toggle="dropdown"]').forEach((el) => {
      new Dropdown(el);
    });
  };

  render() {
    const { publishedBlogs, onEdit, onDelete, onToggleFeatured, featuredId } =
      this.props;

    return (
      <div
        className="row"
        style={{
          overflowY: "auto",
          padding: "10px",
          marginRight: "20px",
        }}
      >
        <p
          style={{
            marginTop: 10,
            fontFamily: "Kumbh Sans",
            paddingBottom: "10px",
            fontSize: themeLarge.fontSize.h3,
            color: themeLarge.colors.text,
            fontWeight: 500,
          }}
        >
          Published Blogs
        </p>

        {publishedBlogs.length === 0 ? (
          <p
            style={{
              fontFamily: "Kumbh Sans",
              fontSize: themeLarge.fontSize.body,
            }}
          >
            No published blogs available.
          </p>
        ) : (
          publishedBlogs.map((blog, index) => (
            <div
              key={blog.id}
              onClick={() => window.open(`/blogs/${blog.slug}`, "_blank")}
              className="d-flex justify-content-between align-items-center mb-2"
              style={{
                cursor: "pointer",
                backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff",
                padding: "20px",
                borderRadius: "10px",
                transition: "background-color 1s ease, color 1s ease",
                boxShadow: themeLarge.shadows.little,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor =
                  themeLarge.colors.gradient;
                e.currentTarget.style.color = "#000";
                e.currentTarget.style.boxShadow = themeLarge.shadows.nothing;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor =
                  index % 2 === 0 ? "#f9f9f9" : "#ffffff";
                e.currentTarget.style.color = "#000";
                e.currentTarget.style.boxShadow = themeLarge.shadows.little;
              }}
            >
              {/* Title + Excerpt */}
              <div style={{ fontFamily: "Kumbh Sans" }}>
                <p
                  style={{
                    fontSize: themeLarge.fontSize.h4,
                    color: themeLarge.colors.text,
                    fontWeight: 500,
                  }}
                >
                  {blog.title}
                </p>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    marginBottom: "10px",
                  }}
                >
                  <FaRegCalendarAlt />
                  <span
                    style={{
                      fontSize: themeLarge.fontSize.small,
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                    }}
                  >
                    {new Date(blog.createdAt).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })}
                  </span>

                  {featuredId === blog.id && (
                    <span
                      title="Featured Blog"
                      style={{
                        paddingLeft: "10px",
                        paddingRight: "15px",
                        paddingTop: "3px",
                        paddingBottom: "3px",
                        borderWidth: "1px",
                        borderColor: themeLarge.colors.text,
                        borderRadius: "15px",
                        borderStyle: "dashed",
                        fontSize: themeLarge.fontSize.small,
                        fontFamily: "Kumbh Sans",
                        color: themeLarge.colors.bg,
                        background: themeLarge.colors.primary,
                      }}
                    >
                      🌟 Featured
                    </span>
                  )}
                </div>
              </div>

              {/* Dropdown */}
              <div className="dropdown">
                <button
                  className="btn btn-link dropdown-toggle"
                  id={`dropdownMenuButton-${blog.id}`}
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  onClick={(e) => {
                    e.stopPropagation(); // ✅ stop the outer div click
                    // allow Bootstrap dropdown to handle the rest
                    // alert("hello world");
                  }}
                >
                  <FaEllipsisV />
                </button>
                <ul
                  className="dropdown-menu"
                  aria-labelledby={`dropdownMenuButton-${blog.id}`}
                >
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={(e) => {
                        e.stopPropagation();
                        onToggleFeatured(blog.id);
                      }}
                    >
                      {featuredId === blog.id ? "Unfeature" : "Make Featured"}
                    </button>
                  </li>
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={(e) => {
                        e.stopPropagation();
                        onEdit(blog.id);
                      }}
                    >
                      Edit
                    </button>
                  </li>
                  <li>
                    <button
                      className="dropdown-item text-danger"
                      onClick={(e) => {
                        e.stopPropagation();
                        onDelete(blog.id);
                      }}
                    >
                      Delete
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          ))
        )}
      </div>
    );
  }
}

export default PublishedBlogsList;
